export enum FitMedProfileGender {
  Male,
  Female,
  Other
}
